/* MISO side cart — AJAX add to cart + right-side drawer. No dependencies. */
(function () {
  var D = document;
  var money = function (cents, cur) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var $ = function (sel) { return D.querySelector(sel); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var root, panel, overlay, list, foot, tab, count, busy = false;

  function open() {
    root.setAttribute('data-open', '1');
    panel.style.transform = 'translateX(0)';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    D.documentElement.style.overflow = 'hidden';
    var c = $('#miso-cart-close'); if (c) c.focus();
  }
  function close() {
    root.removeAttribute('data-open');
    panel.style.transform = '';
    overlay.style.opacity = '';
    overlay.style.pointerEvents = '';
    D.documentElement.style.overflow = '';
  }

  function render(cart) {
    var n = cart.item_count || 0;
    count.textContent = n;
    count.style.display = n ? 'flex' : 'none';
    tab.setAttribute('aria-label', n === 1 ? '1 item in your cart' : n + ' items in your cart');

    if (!n) {
      list.innerHTML = '<div class="miso-cart-empty"><svg width="46" height="46" viewBox="0 0 24 24" fill="none" opacity=".35"><path d="M3 4h2.2l2.3 11.2a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.5L21 8H6.2" stroke="#12456E" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="20" r="1.4" fill="#12456E"/><circle cx="17.5" cy="20" r="1.4" fill="#12456E"/></svg><p>Your cart is empty.</p></div>';
      foot.innerHTML = '<button type="button" class="miso-cart-ghost" data-miso-close>Continue shopping</button>';
      return;
    }

    var rows = cart.items.map(function (it, i) {
      var img = it.image || (it.featured_image && it.featured_image.url) || '';
      var sub = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var plan = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.name) || '';
      return '<div class="miso-cart-row">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '<div class="miso-cart-noimg"></div>') +
        '<div class="miso-cart-info">' +
          '<a class="miso-cart-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (sub ? '<div class="miso-cart-sub">' + esc(sub) + '</div>' : '') +
          (plan ? '<div class="miso-cart-plan">&#8635; ' + esc(plan) + '</div>' : '') +
          '<div class="miso-cart-qty">' +
            '<button type="button" data-miso-qty="' + (i + 1) + '" data-to="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-miso-qty="' + (i + 1) + '" data-to="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '<button type="button" class="miso-cart-remove" data-miso-qty="' + (i + 1) + '" data-to="0">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="miso-cart-price">' + money(it.final_line_price, cart.currency) + '</div>' +
      '</div>';
    }).join('');
    list.innerHTML = rows;

    foot.innerHTML =
      '<div class="miso-cart-sum"><span>Subtotal</span><strong>' + money(cart.total_price, cart.currency) + '</strong></div>' +
      '<p class="miso-cart-note">Free US shipping &middot; free 30-day returns &middot; taxes calculated at checkout</p>' +
      '<a class="miso-cart-go" href="/checkout">Proceed to checkout</a>' +
      '<button type="button" class="miso-cart-ghost" data-miso-close>Continue shopping</button>';
  }

  function refresh(then) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); if (then) then(c); })
      .catch(function () {});
  }

  function addItems(items, btn) {
    if (busy) return; busy = true;
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.setAttribute('data-loading', '1'); btn.innerHTML = 'Adding&hellip;'; }
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { refresh(); open(); })
      .catch(function (err) {
        list.innerHTML = '<div class="miso-cart-empty"><p>' + esc((err && err.description) || 'Sorry — that could not be added to the cart.') + '</p></div>';
        open();
      })
      .finally(function () { busy = false; if (btn) { btn.removeAttribute('data-loading'); btn.innerHTML = label; } });
  }

  function addHandle(handle, btn) {
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        if (!v) throw 0;
        addItems([{ id: v.id, quantity: 1 }], btn);
      })
      .catch(function () { window.location.href = '/products/' + handle; });
  }

  function init() {
    root = $('#miso-cart'); if (!root) return;
    panel = $('#miso-cart-panel'); overlay = $('#miso-cart-overlay');
    list = $('#miso-cart-list'); foot = $('#miso-cart-foot');
    tab = $('#miso-cart-tab'); count = $('#miso-cart-count');

    D.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('#miso-cart-tab')) { e.preventDefault(); refresh(); open(); return; }
      if (t.closest('[data-miso-close]') || t.closest('#miso-cart-overlay')) { e.preventDefault(); close(); return; }

      var q = t.closest('[data-miso-qty]');
      if (q) {
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: Number(q.getAttribute('data-miso-qty')), quantity: Number(q.getAttribute('data-to')) })
        }).then(function (r) { return r.json(); }).then(render).catch(function () {});
        return;
      }

      var bun = t.closest('[data-miso-bundle]');
      if (bun) {
        e.preventDefault();
        var items = null;
        try { items = JSON.parse(bun.getAttribute('data-miso-bundle')); } catch (err) { items = null; }
        if (items && items.length) { addItems(items, bun); return; }
      }

      var a = t.closest('a[href*="/products/"]');
      if (!a) return;
      if (!a.closest('.miso-sales') && !a.closest('.miso-presell')) return;
      if (a.hasAttribute('data-miso-navigate')) return;
      // a Subscribe button on the filter adds it on its plan, rather than walking to the product page
      if (/subscri/i.test(a.textContent)) {
        var fv = root.getAttribute('data-filter-variant');
        var fp = root.getAttribute('data-filter-plan');
        var fh = root.getAttribute('data-filter-handle') || '';
        if (fv && fp && fh && a.getAttribute('href').indexOf(fh) !== -1) {
          e.preventDefault();
          addItems([{ id: Number(fv), quantity: 1, selling_plan: Number(fp) }], a);
        }
        return;
      }
      var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      e.preventDefault();
      addHandle(m[1], a);
    });

    D.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    refresh();
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
